<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <v-data-table
    :headers="getReportRepaymentsHeaders ()"
    :items="getItems ()"
    :loading="repaymentsLoading"
    :items-per-page="rowsPerPage"
    :total-items="rowCount"
    :no-data-text="$t('krita.datagrid.nodata')"
    hide-actions>
    <template v-slot:headers="props">
      <data-grid-sort
        :props="props"
        :pagination="pagination"
        @changeSort="changeSort"
      />
    </template>
    <template v-slot:items="props">
      <tr @click="navigateToRepaymentDetail(props.item.Id)">
        <td><router-link 
          :to="{name: 'Repayment detail', params: {id: props.item.Id}}" 
          target="_self">{{ props.item.Id }}</router-link></td>
        <td>{{ props.item.DebtorName }} ehf (kt. {{ props.item.DebtorRegistryId | kennitala }})</td>
        <td>{{ props.item.FactoringCount }}</td>
        <td>{{ props.item.Amount | amount }}</td>
        <td>{{ props.item.Type }}</td>
        <td>{{ props.item.Status }}</td>
        <td>{{ props.item.CreatedBy }}</td>
        <td>{{ props.item.ExpirationDate | date }}</td>
        <td>{{ props.item.Created | date }}</td>
      </tr>
    </template>
  </v-data-table>
</template>

<script>
import DataGridSort from '../../controllers/DataGridSort'
import EnumIterator from '../../helper/EnumIterator';
    export default {
        name: "RepaymentsDatagrid",
        components: {DataGridSort},
        props: ['repaymentsLoading','repaymentReportData','rowsPerPage','rowCount'],
        data () {
            return {
                pagination:
                    {
                        sortBy: 'id'
                    }
            }
        },
        methods: {
            getReportRepaymentsHeaders ()
            {
                return [
                    {sortable: true, text: this.$t('krita.reports.repayments.header.id'), value: 'id', align: 'left'},
                    {sortable: true, text: this.$t('krita.reports.repayments.header.debtor'), value: 'debtor', align: 'left'},
                    {sortable: false, text: this.$t('krita.reports.repayments.header.factoringcount'), value: 'factoringCount', align: 'left'},
                    {sortable: false, text: this.$t('krita.reports.repayments.header.amount'), value: 'amount', align: 'left'},
                    {sortable: true, text: this.$t('krita.reports.repayments.header.type'), value: 'type', align: 'left'},
                    {sortable: true, text: this.$t('krita.reports.repayments.header.status'), value: 'status', align: 'left'},
                    {sortable: true, text: this.$t('krita.reports.repayments.header.createdby'), value: 'createdBy', align: 'left'},
                    {sortable: true, text: this.$t('krita.reports.repayments.header.expirationdate'), value: 'expirationDate', align: 'left'},
                    {sortable: true, text: this.$t('krita.reports.repayments.header.created'), value: 'created', align: 'left'},
                ]
            },
            navigateToRepaymentDetail (id)
            {
                let self = this;

                self.$router.push('/repayment/' + id);
            },
            changeSort (sort)
            {
                let self = this;

                self.pagination.sortBy = sort.sortBy;
                self.pagination.descending = sort.descending;
                self.$emit('refreshWithSort',self.pagination);
            },
            getItems ()
            {
              let self = this;

              let items = [];
              for (let repaymentReport of self.repaymentReportData)
              {
                let repaymentReportClient = {
                  Amount: repaymentReport.Amount,
                  Created: repaymentReport.Created,
                  CreatedBy: repaymentReport.CreatedBy,
                  DebtorName: repaymentReport.DebtorName,
                  DebtorRegistryId: repaymentReport.DebtorRegistryId,
                  ExpirationDate: repaymentReport.ExpirationDate,
                  FactoringCount: repaymentReport.FactoringCount,
                  Id: repaymentReport.Id,
                  Status: self.$t(EnumIterator.processRepaymentStatus(repaymentReport.Status)),
                  Type: self.$t(EnumIterator.processRepaymentType(repaymentReport.Type)),
                };
                items.push(repaymentReportClient);
              }
              return items;
            },
        }
    }
</script>

<style scoped>

</style>
